import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "gfu-grid gfu-grid--gutter-columns" }
const _hoisted_2 = { class: "gfu-grid__cell gfu-1of1 gfu-6of12--m" }
const _hoisted_3 = { ref: "eps-wrapper" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_field = _resolveComponent("field")

  return (_openBlock(), _createElementBlock("fieldset", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_field, {
        class: "_mt-0",
        "display-name": _ctx.Resources.Checkout.CheckoutAvailableBanksLabel,
        name: "issuer"
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_3, null, 512 /* NEED_PATCH */)
        ]),
        _: 1 /* STABLE */
      }, 8 /* PROPS */, ["display-name"])
    ])
  ]))
}